/**
 * Example auth api connector that lets your user log in using a defined payload
 * and returns a promise
 */

import api from '@/config/api'
import vuex from '@/store'
import resolveStationId from '@/utils/resolveStationId'

export default {
  getTopPitchers(days) {
    const stationId = vuex.getters.currentStation.id
    return api.get(`/v2/newsdesk/dashboard/pitchers`, { params: { 'filter[station_id][]': stationId, days } })
  },
  getContentCounts(type, days) {
    const stationId = vuex.getters.currentStation.id
    days = days ?? 30
    type = type ?? 'storyType'
    return api.get(`/v2/newsdesk/dashboard/${type}`, { params: { 'filter[station_id][]': stationId, days } })
  },
  getAllStationCounts(type, station, days) {
    days = days ?? 30
    type = type ?? 'storyType'
    // 'all' is a real, backend-recognized sentinel meaning "every station" —
    // not a real station name/id, so it can't go through ?filter[station_id][]=.
    // Stays on the legacy path form for that one case; a real station still
    // resolves via the query param.
    if (!station || station === 'all') {
      return api.get(`/v2/newsdesk/dashboard/${type}/all/${days}`)
    }
    return api.get(`/v2/newsdesk/dashboard/${type}`, { params: { 'filter[station_id][]': resolveStationId(station), days } })
  },
  // NOT migrated: this route doesn't exist on the backend at all (confirmed —
  // no `dashboard/today/breakdown` or similar route anywhere in routes/api.php
  // or StationController/StationRepository), regardless of station convention.
  // Pre-existing, broken independent of this ticket's scope; left as-is rather
  // than inventing a URL shape with no backend counterpart to verify against.
  // Flagged in the ND-1490 changelog.
  getShowBreakdown() {
    let station = vuex.getters.currentStation.station
    return api.get(`/v2/newsdesk/dashboard/today/breakdown/${station}`)
  },
  getSafetyPinLocations() {
    const stationId = vuex.getters.currentStation.id
    return api.get(`/v2/newsdesk/safetypin/geo/all`, { params: { 'filter[station_id][]': stationId } })
  }
}
